import {AuthGroupService} from './sfAuthGroupService.js';
import {GPSEventService} from './sfGpsEvents.js';
import {UnitService} from './sfUnitService.js';

export var SecureFuelService = {
	authGroupService: null,
	gpsEventService: null,
	unitService: null,
	
	getAuthGroupService: function(){
		if (!this.authGroupService) {
			this.authGroupService = new AuthGroupService();
		}
		return this.authGroupService;
	},
	
	getGPSEventService: function(){
		if (!this.gpsEventService) {
			this.gpsEventService = new GPSEventService();
		}
		return this.gpsEventService;
	},
	
	getUnitService: function(){
		if (!this.unitService) {
			this.unitService = new UnitService();
		}
		return this.unitService;
	}	
	
};




